import React, { useEffect, useRef, useState } from "react";
import { Col, List, Radio, Row } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import styles from "./../Gallery.module.css";
import SearchInput from "../../../../../components/searchInput/SearchInput";
import SubmitButton from "../../../../../components/submitButton/SubmitButton";
import { DropDown, InputField, TextComponent } from "../../../../../components";
import Storage from "../../../../../utills/AsyncStorage";
import { PhotosMiddleware } from "../../../../../Store/Middlewares/PhotosMiddleware";
import Modal from "../../../../../components/modal/Modal";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";
import dummyImg from '../../../../../assets/imageplace.jpg';

 const WeddingHighlightDetails = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const { state } = useLocation();
    const AlbumData = useSelector((state) => state.PhotosReducer.Album);
    const AlbumPagination = useSelector(
      (state) => state.PhotosReducer.AlbumPagination
    );
    // console.log("AlbumData", AlbumData?.[0]);
  
    const navigation = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
      getAlbumData();
    }, []);
  
    const getAlbumData = () => {
      let data = {
        event_id: state?.item?.event_id,
        user_id: state?.item?.user_id,
        next_page_url: undefined,
      };
      dispatch(PhotosMiddleware.getAlbumPhotos(data));
    };
    const onPressRenderMoreContent = () => {
      let data = {
        event_id: state?.item?.event_id,
        user_id: state?.item?.user_id,
        next_page_url: AlbumPagination?.links?.next,
      };
      dispatch(PhotosMiddleware.getAlbumPhotos(data));
    };
  const renderMyImages = (item, index) => {
    if (item?.type == "video") {
      return (
        <div key={index} className={styles.listItem} 
        onClick={() =>
          navigation("/events/singleImage", {
            state: { headrTitle: "Gallery", item: item },
          })
        }
        >
          <div className={styles.square}>
            <video className={styles.video} controls>
              <source src={item?.files} />
            </video>
          </div>
        </div>
      );
    } else {
      return (
        <div
          key={index}
          className={styles.listItem}
          onClick={() =>
            navigation("/events/singleImage", {
              state: { headrTitle: "Gallery", item: item },
            })
          }
        >
          <div className={styles.square}>
            <img src={item?.image ? item?.image : dummyImg} className={styles.listImg} />
            <div className={styles.ItemName}>
              <TextComponent text={item?.name} textClass={styles.nameTxt} />
            </div>
          </div>
        </div>
      );
    }
  };
  return (
    <div className={styles.mainCon}>
      {/* <Row className={styles.head} gutter={12}>
        <Col xs={24} sm={16} lg={18} className={styles.headLeft}>
          <SearchInput placeholder={"Search"} value={search} onChange={(e)=>onSearch(e.target.value)}/>
        </Col>
        <Col xs={24} sm={8} lg={6} className={styles.headRight}>
          <SubmitButton
            title={"Upload Photo"}
            onClick={() => navigation("/events/uploadGallery",{
              state: event_id
            })}
          /> 
            <SubmitButton
            title={"Category"}
            btnClass={styles.btn}
            onClick={() => setCategoryModal(true)}
          />
        </Col>
      </Row> */}
      {/* <div className={styles.txtDiv}>
        <TextComponent
          text={
            "Collect and save event photos from your guests to enjoy for a lifetime. Because it only happens once!"
            // role === roles.guest
            //   ? "Upload wedding photos of your Event to enjoy for a lifetime. Because it only happens once!"
            //   : "Collect and save wedding photos from your guests to enjoy for a lifetime. Because it only happens once!"
          }
          textClass={styles.Txt}
        />
      </div> */}
      <TextComponent
        text={
          state?.eventData?.name ? state?.eventData?.name : "--"
          // role === roles.guest
          //   ? "James and Lucy Marriage"
          //   : "Engagement Ceremony"
        }
        textClass={styles.headingTxt}
      />
      <List
        className={styles.list}
        grid={{ gutter: 16 }}
        itemLayout="horizontal"
        dataSource={AlbumData}
        renderItem={renderMyImages}
        footer={
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {AlbumPagination?.links?.next != null ? (
              <div style={{ width: "50%" }}>
                <SubmitButton
                  title={"Load More"}
                  onClick={onPressRenderMoreContent}
                />
              </div>
            ) : null}
          </div>
        }
      />
    </div>
  );
};

export default WeddingHighlightDetails